import styled from 'styled-components';
import Parent from './style';
const Wrapper = styled(Parent.Wrapper)`

`;
const TopWrapper = styled(Parent.TopWrapper)`
 
`;
const IconWrapper = styled(Parent.IconWrapper)`
margin-left: 2px;
align-self: center;
`;

const ImpExpWrapper = styled(Parent.ImpExpWrapper)`
flex: 1;
.importUserTemplateContainer{
.MuiAvatar-root { 
  width: 16px !important;
  height: 16px !important;
}
}
.exportContainer .MuiAvatar-root { 
  width: 16px !important;
  height: 16px !important;
}
.importUserContainer .csv-reader-input .tooltiptext{
  ${window?.$environment?.clutchNewUI && `font-weight: bold;`}
}
`;

const SearchWrapper = styled(Parent.SearchWrapper)`

`;

const ButtonsWrapper = styled(Parent.ButtonsWrapper)`
${({theme})=>`
.MuiButton-root {
  font-size: 12px !important;
  background: transparent !important;
  ${window?.$environment?.clutchNewUI && 
    `border: 2px solid ${theme.colors.ACTION_BORDER}};`
  }
`}
`;

const DocContainer = styled(Parent.DocContainer)`
border: 1px solid rgba(255,255,255,0.66) !important;
a {
  font-size: 14px;
  text-decoration: none;
}
`;
const TableWrapper = styled(Parent.TableWrapper)`
table {
.MuiTableBody-root .MuiTableCell-root:nth-child(8) {
  justify-content: center;
  width: 50px !important;
}
.MuiTableHead-root .MuiTableRow-root .MuiTableCell-root:nth-child(7){
    text-align: left !important;
}

}
`;
const Styled = {
  Wrapper,
  IconWrapper,
  ImpExpWrapper,
  SearchWrapper,
  TopWrapper,
  ButtonsWrapper,
  TableWrapper,
  DocContainer
};
export default Styled;
